import { TargetEnvironment } from './environment.interfaces';

export const environment = {
	production: false,
	baseurl: 'https://api-results.tms.test.scania.com:443/api/',
	reportsurl: 'https://reports.tms.test.scania.com/',
	fenixReportsUrl: 'https://reports.testtools.devtest.gf.aws.scania.com/',
	reportsapiurl: 'https://apireports.tms.test.scania.com/',
	requirementsurl: 'https://polarion-dev.scania.com/polarion/#/',
	environment: TargetEnvironment.Default,
	launchDarklyClientId: '664590c02c638010dc55095f',
	abstractionLayerStagingUrl: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
	abstractionLayerReleaseUrl: 'https://5oetsllb2jfelbghdyob2uy2r4.appsync-api.eu-north-1.amazonaws.com/graphql',
	apiStagingUrl: 'https://pfx2yyriv5bz3dwszzs7w5qgni.appsync-api.eu-north-1.amazonaws.com/graphql',
	apiReleaseUrl: 'https://xef6knwn7vhq5h26seu6dh5hf4.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayerStagingUrl: 'https://ehlfaue7jfexfalnchzbb672sq.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayerReleaseUrl: 'https://tfsusyfgjnaitctqbnqad3v2bq.appsync-api.eu-north-1.amazonaws.com/graphql',
	externalAbstractionLayerStagingUri: 'https://55hhprzqirhh5ajoczvlv4yhka.appsync-api.eu-north-1.amazonaws.com/graphql',
	externalAbstractionLayerReleaseUri: 'https://yfprtdiavnh5ffaai5ghzs7fei.appsync-api.eu-north-1.amazonaws.com/graphql',
	logConfig: {
		application: 'resultsweb',
		env: 'dev',
		graphqlUrl: 'https://kftht5tfp5b6tfwm6kzqa7ijzu.appsync-api.eu-north-1.amazonaws.com/graphql',
		logLevel: 2,
		console: true,
		debounceTime: 5000,
	},
	cognitoConfig: {
		domain: 'https://eu-north-1shrtzdylx.auth.eu-north-1.amazoncognito.com',
		clientId: '5o1rfk53tk76ntdnf91miipke',
		scopes: ['openid', 'email', 'phone'],
		redirectUri: 'https://results.testtools.devtest.gf.aws.scania.com/',
	},
	oneTimeTokenName: 'fenixOneTimeToken',
	redirectUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/login',
	homeUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com',
	wikiUrl: 'https://confluence.collaborationlayer-traton.com/spaces/TW/pages/88968932/6+Fenix+Results',
	supportUrl:
		'https://teams.microsoft.com/l/team/19%3Af0563924f10948e29b24c3580bfa34a6%40thread.tacv2/conversations?groupId=34884b53-40a8-4388-b61a-a801abce4000&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
};
export const Config = {
	colaConfig: {
		disabled: false,
		redirectUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/login',
	},
};
